var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_107",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 12.8333C7.76618 12.8342 8.52499 12.6838 9.23285 12.3906C9.94071 12.0974 10.5837 11.6672 11.1247 11.1247C11.6672 10.5836 12.0974 9.94068 12.3906 9.23282C12.6838 8.52496 12.8343 7.76615 12.8333 6.99996C12.8343 6.23378 12.6838 5.47496 12.3906 4.76711C12.0974 4.05925 11.6672 3.41631 11.1247 2.87521C10.5837 2.33276 9.94071 1.90257 9.23285 1.60936C8.52499 1.31614 7.76618 1.16569 6.99999 1.16663C6.23381 1.16569 5.47499 1.31614 4.76714 1.60936C4.05928 1.90257 3.41634 2.33276 2.87524 2.87521C2.33279 3.41631 1.9026 4.05925 1.60939 4.76711C1.31617 5.47496 1.16572 6.23378 1.16666 6.99996C1.16572 7.76615 1.31617 8.52496 1.60939 9.23282C1.9026 9.94068 2.33279 10.5836 2.87524 11.1247C3.41634 11.6672 4.05928 12.0974 4.76714 12.3906C5.47499 12.6838 6.23381 12.8342 6.99999 12.8333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99998 10.7916C7.19337 10.7916 7.37883 10.7148 7.51558 10.578C7.65232 10.4413 7.72915 10.2558 7.72915 10.0624C7.72915 9.86903 7.65232 9.68356 7.51558 9.54682C7.37883 9.41007 7.19337 9.33325 6.99998 9.33325C6.80659 9.33325 6.62113 9.41007 6.48438 9.54682C6.34764 9.68356 6.27081 9.86903 6.27081 10.0624C6.27081 10.2558 6.34764 10.4413 6.48438 10.578C6.62113 10.7148 6.80659 10.7916 6.99998 10.7916Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.5V8.16667",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V14H0V0Z",
    fill: "#706F6F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/Attention.f934ff59e3ccef23277b1546cdd5af87.svg";
export { ForwardRef as ReactComponent };